import React from "react";
import { withStyles } from "@mui/styles";
import Badge from "@mui/material/Badge";

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: theme.spacing(0.5),
    backgroundColor: (props) => (props.color ? props.color : "#07a507"),
    padding: "0px",
    height: theme.spacing(2),
    width: theme.spacing(2),
    minWidth: theme.spacing(2),
  },
}))(Badge);

export default StyledBadge;
